import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "filter-factory" }
const _hoisted_2 = { class: "filter-factory__filters" }
const _hoisted_3 = {
  key: 8,
  class: "filter-factory__product"
}
const _hoisted_4 = { class: "filter-factory__buttons" }
const _hoisted_5 = {
  key: 0,
  class: "filter-factory__buttons-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_SelectMultiComponentCheckbox = _resolveComponent("SelectMultiComponentCheckbox")!
  const _component_TreeMultiselect = _resolveComponent("TreeMultiselect")!
  const _component_DateRangeField = _resolveComponent("DateRangeField")!
  const _component_TimeRangeField = _resolveComponent("TimeRangeField")!
  const _component_NumberRangeField = _resolveComponent("NumberRangeField")!
  const _component_TreeSelectionProducts = _resolveComponent("TreeSelectionProducts")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_FilterWrapper = _resolveComponent("FilterWrapper")!
  const _component_FilterActions = _resolveComponent("FilterActions")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtersConfig, (filterConfig) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "filter-factory__item",
          key: filterConfig.label
        }, [
          _createVNode(_component_FilterWrapper, {
            disabled: _ctx.getIsResettableDisabled(filterConfig),
            onDisable: ($event: any) => (_ctx.handleDisabledFilterReset(filterConfig))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputBlock, {
                title: _ctx.getFilterTitle(filterConfig),
                required: filterConfig.required
              }, {
                default: _withCtx(() => [
                  (filterConfig.type === 'text')
                    ? (_openBlock(), _createBlock(_component_ComponentInput, {
                        key: 0,
                        modelValue: _ctx.filter[filterConfig.vModel],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filter[filterConfig.vModel]) = $event),
                        maxLength: filterConfig.maxLength ?? 255,
                        placeholder: filterConfig.placeholder ?? 'Введите',
                        mod: "rectangular",
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig),
                        clearButton: filterConfig.clearable,
                        onOnClear: ($event: any) => (_ctx.resetFilterValue(filterConfig)),
                        isDirtyValidation: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "maxLength", "placeholder", "required", "disabled", "clearButton", "onOnClear"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'checkbox')
                    ? (_openBlock(), _createBlock(_component_CheckboxInput, {
                        key: 1,
                        modelValue: Boolean(_ctx.filter[filterConfig.vModel]),
                        "onUpdate:modelValue": ($event: any) => (_ctx.filter[filterConfig.vModel] = $event),
                        id: filterConfig.vModel,
                        label: filterConfig.label,
                        disabled: _ctx.getIsDisabledFilter(filterConfig)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "label", "disabled"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'select')
                    ? (_openBlock(), _createBlock(_component_SelectMultiComponent, {
                        key: 2,
                        modelValue: _ctx.filter[filterConfig.vModel],
                        "onUpdate:modelValue": [($event: any) => ((_ctx.filter[filterConfig.vModel]) = $event), ($event: any) => (_ctx.filterSelectFilters(filterConfig))],
                        options: _ctx.getSelectOptions(filterConfig),
                        placeholder: filterConfig.placeholder ?? 'Выберите',
                        searchMaxLength: filterConfig.maxLength ?? 255,
                        modifier: "rectangular",
                        valueProp: filterConfig.valueProp,
                        trackBy: filterConfig.labelProp,
                        label: filterConfig.labelProp,
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig),
                        clearClass: filterConfig.clearable,
                        canClear: filterConfig.clearable,
                        loadingList: filterConfig.loadingList,
                        isDirtyValidation: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "searchMaxLength", "valueProp", "trackBy", "label", "required", "disabled", "clearClass", "canClear", "loadingList"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'multi-select')
                    ? (_openBlock(), _createBlock(_component_SelectMultiComponentCheckbox, {
                        key: 3,
                        modelValue: _ctx.filter[filterConfig.vModel],
                        "onUpdate:modelValue": [($event: any) => ((_ctx.filter[filterConfig.vModel]) = $event), ($event: any) => (_ctx.filterSelectFilters(filterConfig))],
                        options: _ctx.getSelectOptions(filterConfig),
                        placeholder: filterConfig.placeholder ?? 'Выберите',
                        valueProp: filterConfig.valueProp,
                        trackBy: filterConfig.labelProp,
                        labelOptions: filterConfig.labelProp,
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig),
                        textError: filterConfig.textError,
                        customValidations: filterConfig.customValidations,
                        isDirtyValidation: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "valueProp", "trackBy", "labelOptions", "required", "disabled", "textError", "customValidations"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'tree-select')
                    ? (_openBlock(), _createBlock(_component_TreeMultiselect, {
                        key: 4,
                        modelValue: _ctx.getTreeMultiselectFilterValue(filterConfig),
                        "onUpdate:modelValue": ($event: any) => (_ctx.setTreeMultiselectSelectValue($event, filterConfig)),
                        options: filterConfig.options,
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig),
                        textError: filterConfig.textError,
                        levelEventsLabels: filterConfig.levelEventsLabels,
                        customValidations: filterConfig.customValidations,
                        valueProp: filterConfig.valueProp,
                        labelProp: filterConfig.labelProp,
                        childrenProp: filterConfig.childrenProp,
                        placeholder: filterConfig.placeholder,
                        noResultsText: filterConfig.noResultsText,
                        noOptionsText: filterConfig.noOptionsText,
                        isSingleMode: filterConfig.isSingleMode,
                        menuMode: filterConfig.menuMode,
                        isDirtyValidation: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "required", "disabled", "textError", "levelEventsLabels", "customValidations", "valueProp", "labelProp", "childrenProp", "placeholder", "noResultsText", "noOptionsText", "isSingleMode", "menuMode"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'date')
                    ? (_openBlock(), _createBlock(_component_DateRangeField, {
                        key: 5,
                        from: _ctx.getRangeValue(filterConfig, true),
                        to: _ctx.getRangeValue(filterConfig, false),
                        "onUpdate:from": ($event: any) => (_ctx.setRangeValue(filterConfig, true, $event)),
                        "onUpdate:to": ($event: any) => (_ctx.setRangeValue(filterConfig, false, $event)),
                        mode: _ctx.getDatePickerMode(filterConfig),
                        placeholders: filterConfig.placeholders,
                        typeable: filterConfig.typeable,
                        hasInputMask: filterConfig.hasInputMask,
                        limits: filterConfig.limits,
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig)
                      }, null, 8, ["from", "to", "onUpdate:from", "onUpdate:to", "mode", "placeholders", "typeable", "hasInputMask", "limits", "required", "disabled"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'time')
                    ? (_openBlock(), _createBlock(_component_TimeRangeField, {
                        key: 6,
                        from: _ctx.getRangeValue(filterConfig, true),
                        to: _ctx.getRangeValue(filterConfig, false),
                        "onUpdate:from": ($event: any) => (_ctx.setRangeValue(filterConfig, true, $event)),
                        "onUpdate:to": ($event: any) => (_ctx.setRangeValue(filterConfig, false, $event)),
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig)
                      }, null, 8, ["from", "to", "onUpdate:from", "onUpdate:to", "required", "disabled"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'rangeNumber')
                    ? (_openBlock(), _createBlock(_component_NumberRangeField, {
                        key: 7,
                        from: _ctx.getRangeValue(filterConfig, true),
                        to: _ctx.getRangeValue(filterConfig, false),
                        "onUpdate:from": ($event: any) => (_ctx.setRangeValue(filterConfig, true, $event)),
                        "onUpdate:to": ($event: any) => (_ctx.setRangeValue(filterConfig, false, $event)),
                        placeholders: [filterConfig.placeholderFrom ?? 'Введите', filterConfig.placeholderTo ?? 'Введите'],
                        required: filterConfig.required,
                        disabled: _ctx.getIsDisabledFilter(filterConfig)
                      }, null, 8, ["from", "to", "onUpdate:from", "onUpdate:to", "placeholders", "required", "disabled"]))
                    : _createCommentVNode("", true),
                  (filterConfig.type === 'product')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_TreeSelectionProducts, {
                          selectedIdsProps: _ctx.getProductSelectedIds(filterConfig),
                          onUpdateSelectedIDs: 
                    (ids) => _ctx.updateSelectedIDs(ids, `${filterConfig.vModel}${_ctx.filterPostfixKey.CODES}`)
                  ,
                          isInitClearValue: false,
                          required: filterConfig.required,
                          disabled: _ctx.getIsDisabledFilter(filterConfig),
                          multiple: filterConfig.multiple,
                          fetcher: filterConfig.fetcher,
                          updateSelectedItems: filterConfig.valueUpdated,
                          isDirtyValidation: ""
                        }, null, 8, ["selectedIdsProps", "onUpdateSelectedIDs", "required", "disabled", "multiple", "fetcher", "updateSelectedItems"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title", "required"])
            ]),
            _: 2
          }, 1032, ["disabled", "onDisable"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FilterActions, { actions: _ctx.filterActions }, null, 8, ["actions"]),
      (_ctx.$slots.buttons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}